<!--===============================
=            TABLEAPEX            =
================================-->
<template>
  <div class="row">
    <table class="table table-centered mb-0 subtitle-2">
      <thead class="thead-light black--text">
        <tr>
          <th>Total Value</th>
          <th>Percentage of Portfolio</th>
          <th>Last 10 days</th>
          <th>Volume</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>$32,554</td>
          <td>15%</td>
          <td>
            <div id="chart-1"></div>
          </td>
          <td>
            <div id="chart-5"></div>
          </td>
        </tr>
        <tr>
          <td>$23,533</td>
          <td>7%</td>
          <td>
            <div id="chart-2"></div>
          </td>
          <td>
            <div id="chart-6"></div>
          </td>
        </tr>
        <tr>
          <td>$54,276</td>
          <td>9%</td>
          <td>
            <div id="chart-3"></div>
          </td>
          <td>
            <div id="chart-7"></div>
          </td>
        </tr>
        <tr>
          <td>$11,533</td>
          <td>2%</td>
          <td>
            <div id="chart-4"></div>
          </td>
          <td>
            <div id="chart-8"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  mounted() {
    window.Apex = {
      stroke: {
        width: 3
      },
      markers: {
        size: 0
      },
      tooltip: {
        fixed: {
          enabled: true
        }
      }
    };

    var randomizeArray = function(arg) {
      var array = arg.slice();
      var currentIndex = array.length,
        temporaryValue,
        randomIndex;

      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    };

    // data for the sparklines that appear below header area
    var sparklineData = [
      47,
      45,
      54,
      38,
      56,
      24,
      65,
      31,
      37,
      39,
      62,
      51,
      35,
      41,
      35,
      27,
      93,
      53,
      61,
      27,
      54,
      43,
      19,
      46
    ];

    var options1 = {
      series: [
        {
          data: [25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54]
        }
      ],
      chart: {
        type: "line",
        width: 100,
        height: 35,
        sparkline: {
          enabled: true
        }
      },
      color: ["#e34956"],
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function(seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var chart1 = new ApexCharts(document.querySelector("#chart-1"), options1);
    chart1.render();

    var options2 = {
      series: [
        {
          data: [12, 14, 2, 47, 42, 15, 47, 75, 65, 19, 14]
        }
      ],
      chart: {
        type: "line",
        width: 100,
        height: 35,
        sparkline: {
          enabled: true
        }
      },
      color: ["#e34956"],
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function(seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var chart2 = new ApexCharts(document.querySelector("#chart-2"), options2);
    chart2.render();

    var options3 = {
      series: [
        {
          data: [47, 45, 74, 14, 56, 74, 14, 11, 7, 39, 82]
        }
      ],
      chart: {
        type: "line",
        width: 100,
        height: 35,
        sparkline: {
          enabled: true
        }
      },
      color: ["#e34956"],
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function(seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var chart3 = new ApexCharts(document.querySelector("#chart-3"), options3);
    chart3.render();

    var options4 = {
      series: [
        {
          data: [15, 75, 47, 65, 14, 2, 41, 54, 4, 27, 15]
        }
      ],
      chart: {
        type: "line",
        width: 100,
        height: 35,
        sparkline: {
          enabled: true
        }
      },
      color: ["#e34956"],
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function(seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var chart4 = new ApexCharts(document.querySelector("#chart-4"), options4);
    chart4.render();

    var options5 = {
      series: [
        {
          data: [25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54]
        }
      ],
      chart: {
        type: "bar",
        width: 100,
        height: 35,
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        bar: {
          columnWidth: "80%"
        }
      },
      labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      xaxis: {
        crosshairs: {
          width: 1
        }
      },
      color: ["#e34956"],
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function(seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var chart5 = new ApexCharts(document.querySelector("#chart-5"), options5);
    chart5.render();

    var options6 = {
      series: [
        {
          data: [12, 14, 2, 47, 42, 15, 47, 75, 65, 19, 14]
        }
      ],
      chart: {
        type: "bar",
        width: 100,
        height: 35,
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        bar: {
          columnWidth: "80%"
        }
      },
      labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      xaxis: {
        crosshairs: {
          width: 1
        }
      },
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function(seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var chart6 = new ApexCharts(document.querySelector("#chart-6"), options6);
    chart6.render();

    var options7 = {
      series: [
        {
          data: [47, 45, 74, 14, 56, 74, 14, 11, 7, 39, 82]
        }
      ],
      chart: {
        type: "bar",
        width: 100,
        height: 35,
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        bar: {
          columnWidth: "80%"
        }
      },
      labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      xaxis: {
        crosshairs: {
          width: 1
        }
      },
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function(seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var chart7 = new ApexCharts(document.querySelector("#chart-7"), options7);
    chart7.render();

    var options8 = {
      series: [
        {
          data: [25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54]
        }
      ],
      chart: {
        type: "bar",
        width: 100,
        height: 35,
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        bar: {
          columnWidth: "80%"
        }
      },
      labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      xaxis: {
        crosshairs: {
          width: 1
        }
      },
      tooltip: {
        fixed: {
          enabled: false
        },
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function(seriesName) {
              return "";
            }
          }
        },
        marker: {
          show: false
        }
      }
    };
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var chart8 = new ApexCharts(document.querySelector("#chart-8"), options8);
    chart8.render();
  }
};
</script>


<!--====  End of TABLEAPEX  ====-->